import type { LensCard } from '~/types/leLens';

/** Presentation columns belong to the approved type, source and measure/group projection. */
export function configuredTablePresentationChanged(saved: LensCard, edited: LensCard): boolean {
  if (!saved.config?.tableColumns?.length) return false;
  if (saved.type !== edited.type || saved.datasetId !== edited.datasetId) return true;
  return (['x', 'series', 'value', 'values', 'ratio', 'aggregate'] as const).some(
    (key) => JSON.stringify(saved.view?.[key] ?? null) !== JSON.stringify(edited.view?.[key] ?? null),
  );
}

/** Explicit field/type edits leave configured columns; filters, periods and appearance do not. */
export function editedTablePresentation(saved: LensCard, edited: LensCard): LensCard {
  if (!configuredTablePresentationChanged(saved, edited) || !edited.config?.tableColumns) return edited;
  const { tableColumns: _tableColumns, ...config } = edited.config;
  return { ...edited, config };
}
